import { Typography } from "@mui/material";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { ForwardRefRenderFunction, forwardRef, memo } from "react";
import { useTranslation } from "react-i18next";

export interface GenDatePickerProps
  extends Omit<DatePickerProps, "renderInput"> {
  error?: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
}

const GenDatePicker: ForwardRefRenderFunction<
  DatePickerProps,
  GenDatePickerProps
> = (props, ref) => {
  const { t } = useTranslation();
  const { label, required } = props;

  return (
    // <LocalizationProvider dateAdapter={AdapterDateFns}>
    <>
      <DatePicker
        {...props}
        label={
          <>
            {label}
            {required ? (
              <Typography component="span" color="error">
                *
              </Typography>
            ) : (
              ""
            )}
          </>
        }
        sx={{
          width: "100%",
          marginTop: 0,
          marginBottom: props.error?.length ? 0 : 1,
        }}
        format="dd/MM/yyyy"
      />
      {props.placeholder?.length && (
        <Typography
          component={"div"}
          variant="caption"
          marginTop={0}
          marginLeft={1.5}
          padding={0}
          marginBottom={props.error?.length ? -1 : -1}
        >
          {t(props.placeholder)}
        </Typography>
      )}
      {props.error?.length && (
        <Typography
          variant="caption"
          color="error"
          marginTop={-2}
          marginLeft={1.5}
        >
          {t(props.error)}
        </Typography>
      )}
    </>
    // </LocalizationProvider>
  );
};

export default memo(forwardRef(GenDatePicker));
